import React from 'react';
import { Nullable } from 'global';
import { moneyService } from 'shared';
import { Divider, Stack, Typography } from '@mui/material';

import { QuoteCalcBreachBreakdown } from '../../../../api/types';

interface Props {
  message: string;
  breakdown: Nullable<QuoteCalcBreachBreakdown>;
}

export const BreachTooltip = ({ message, breakdown }: Props) => (
  <Stack maxWidth="20rem" gap="0.5rem">
    <Typography variant="body2" fontWeight={600}>
      {message}
    </Typography>

    {breakdown && (
      <>
        <Divider color="white" />

        {breakdown.contributions.map(contribution => (
          <Stack gap="0.75rem" direction="row" key={contribution.key} justifyContent="space-between">
            <Typography variant="caption">{contribution.label}</Typography>

            <Typography variant="caption">{moneyService.formatUsd(contribution.amount)}</Typography>
          </Stack>
        ))}

        <Divider color="white" />

        <Stack direction="row" justifyContent="space-between" gap="0.75rem">
          <Typography variant="caption" fontWeight={600}>
            Rolled total
          </Typography>

          <Typography variant="caption" fontWeight={600}>
            {moneyService.formatUsd(breakdown.total)}
          </Typography>
        </Stack>
      </>
    )}
  </Stack>
);
